import { FC, Suspense } from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { LoginPage, PunchlistLoader, RegisterPage } from '../components/templates'
import { authActions } from '../ducks/actions'
import { useAppDispatch } from '../ducks/hooks'
import { getConfigValue, getNewEstimateValue, isAuthorized } from '../ducks/selectors'
import { RoutesType } from './types'



const AuthRoutes: FC<RoutesType> = ({ children, location }) => {
  const authorized = useSelector(isAuthorized)
  const redirectPath = useSelector(getConfigValue('redirectPath'))
  const dispatch = useAppDispatch()
  const userIsloggedIn = useSelector(getNewEstimateValue('userIsloggedIn'))

  if (!authorized && userIsloggedIn) {
    // clean persisted estimate data when auth0 token expired
    dispatch(
      authActions.logoutRequest({
        callback: (success) => {
          // if (success) replace('/')
        },
      })
    )
  }

  if (authorized) {
    if (redirectPath && redirectPath !== "/p/docusignSuccess") {
      return <Redirect to={redirectPath} />
    }
    return <Redirect to='/p/dashboard' />
  }

  if (location?.pathname === "register") {
    return (
      <Suspense fallback={<PunchlistLoader />}>
        <RegisterPage>
          {children}
        </RegisterPage>
      </Suspense>
    )
  } else {
    return (
      <Suspense fallback={<PunchlistLoader />}>
        <LoginPage>
          {children}
        </LoginPage>
      </Suspense>
    )
  }

}

export default AuthRoutes
